//var siteURLGlobal = 'https://mv2.lcsthlm.com';
var siteURLGlobal = 'https://mv2.lcsthlm.com';